export default __webpack_public_path__ + "static/services-consulting-b0b208b05137d9cbad26634eeb4a3cbc.jpg";